<div *ngIf="customerModel" class="me-3">
    <div #customerPageScroll [ngClass]="{ 'full-screen': !isDialog }">
        <!-- SKEDIT PAY - READ THIS SO YOU DONT SPEND 20 MIN TYRING TO ADD AN EVENT EMITTER INTO THE WRONG COMPONENT -->
        <div *ngIf="skeditPay">
            <slick-tabs (tabChange)="onTabChanged($event)">
                <slick-tab icon="bi bi-person-fill">
                    <div style="max-height: calc(100vh - 350px); overflow-y: auto;">
                        <customer-edit-layout #customerEditLayoutRef *ngIf="tabKey === 'Customer'" [(customerModel)]="customerModel"></customer-edit-layout>
                    </div>
                </slick-tab>
                <slick-tab *ngIf="usingCreditCards" header="Payment Info" icon="bi bi-credit-card-fill">
                    <payment-info-edit *ngIf="tabKey === 'Payment Info'" [(customerModel)]="customerModel"></payment-info-edit>
                </slick-tab>
                <slick-tab header="Documents" icon="bi bi-file-earmark-text-fill">
                    <documents-edit *ngIf="tabKey === 'Documents'"
                                    [documentKey]="customerModel.documentKey"
                                    documentType="Customers"
                                    folderType="documents"
                                    [canDelete]="customersAuthService.canEdit()"
                                    [hideFileDrop]="!customersAuthService.canEdit()"></documents-edit>
                </slick-tab>
                <slick-tab header="System Logs" icon="bi bi-info-circle-fill">
                    <div style="max-height: calc(100vh - 350px); overflow-y:auto;">
                        <system-logs *ngIf="tabKey === 'System Logs'" [referenceId]="customerModel.customerId" noteType="0"></system-logs>
                    </div>
                </slick-tab>
            </slick-tabs>
        </div>

        <!-- NOT SKEDIT PAY -->
        <div *ngIf="!skeditPay && !isEditingCustomer" class="customer-dashboard">
            <div class="customer-dashboard-actions">
                <button type="button" class="btn btn-link text-primary customer-action-link" (click)="openSystemLogs()">
                    System Logs
                </button>

                <button type="button"
                        *ngIf="canUseTextChat"
                        class="btn btn-outline-secondary customer-action-button"
                        (click)="openTextChat()">
                    <i class="bi bi-chat-left-text"></i> Text Chat
                </button>

                <div class="customer-action-menu">
                    <button type="button"
                            class="btn btn-primary customer-action-button"
                            (click)="toggleMenu('create', $event)">
                        <i class="bi bi-plus-lg"></i> Create <i class="bi bi-chevron-down ms-1"></i>
                    </button>

                    <div class="dropdown-menu show customer-action-menu-list" *ngIf="openMenu === 'create'">
                        <button type="button" class="dropdown-item" *ngIf="jobsAuthService.canAdd()" (click)="createJob()">
                            <i class="bi bi-briefcase"></i> Job
                        </button>
                        <button type="button" class="dropdown-item" *ngIf="estimatesAuthService.canAdd()" (click)="createQuote()">
                            <i class="bi bi-file-earmark-text"></i> Quote
                        </button>
                        <button type="button" class="dropdown-item" *ngIf="invoicesAuthService.canAdd()" (click)="createInvoice()">
                            <i class="bi bi-receipt"></i> Invoice
                        </button>
                        <button type="button" class="dropdown-item" *ngIf="paymentsAuthService.canAdd()" (click)="createPayment()">
                            <i class="bi bi-cash-coin"></i> Payment
                        </button>
                        <div *ngIf="canAddPipelineLead" class="dropdown-divider"></div>
                        <button type="button" class="dropdown-item" *ngIf="canAddPipelineLead" (click)="createLead()">
                            <i class="bi bi-kanban"></i> Add to Pipeline Lead
                        </button>
                    </div>
                </div>

                <div class="customer-action-menu">
                    <button type="button"
                            class="btn btn-outline-secondary customer-action-button"
                            (click)="toggleMenu('more', $event)">
                        More <i class="bi bi-chevron-down ms-1"></i>
                    </button>

                    <div class="dropdown-menu show customer-action-menu-list" *ngIf="openMenu === 'more'">
                        <button type="button"
                                class="dropdown-item"
                                [disabled]="!customerModel.email"
                                (click)="sendServiceAgreement()">
                            <i class="bi bi-envelope"></i> Send Service Agreement
                        </button>
                        <button type="button"
                                class="dropdown-item"
                                [disabled]="!customerModel.email"
                                (click)="sendCustomerPortalLink()">
                            <i class="bi bi-box-arrow-up-right"></i> Send Customer Portal Link
                        </button>
                        <button type="button" class="dropdown-item" disabled title="Coming soon">
                            <i class="bi bi-file-earmark-bar-graph"></i> Create Statement
                        </button>
                    </div>
                </div>
            </div>

            <!-- Same red banners the customer card shows on jobs and invoices -->
            <div *ngIf="customerModel.customerAttentionNote" class="alert alert-danger customer-attention-note" role="alert">
                <i class="bi bi-exclamation-circle-fill"></i>
                <b>Attention:</b> {{ customerModel.customerAttentionNote }}
            </div>

            <div *ngIf="customerModel.creditHold || customerModel.creditHoldNotes" class="alert alert-danger customer-attention-note" role="alert">
                <i class="bi bi-exclamation-octagon-fill"></i>
                <b>{{ customerModel.criticalCreditHold ? 'Critical Credit Hold' : 'Credit Hold' }}<ng-container *ngIf="customerModel.creditHoldNotes">:</ng-container></b>
                {{ customerModel.creditHoldNotes }}
            </div>

            <div class="customer-dashboard-header">
                <div class="customer-main-info">

                    <div class="d-flex align-items-start">
                        <div>
                            <h2 class="customer-name">
                                {{ customerModel.lastName }}, {{ customerModel.firstName }}
                            </h2>
                            <div *ngIf="customerModel.companyName" class="customer-company-name">
                                {{ customerModel.companyName }}
                            </div>
                            <div>{{ customerModel.address1 }}</div>
                            <div>{{ customerModel.city }}, {{ customerModel.state }} {{ customerModel.zipcode }}</div>

                            <div class="customer-contact-info">
                                <div class="customer-contact-line">
                                    <i class="bi bi-telephone-fill"></i>
                                    <b>Cell:</b>
                                    <span *ngIf="customerModel.cellPhone">{{ customerModel.cellPhone }}</span>
                                    <span *ngIf="!customerModel.cellPhone" class="text-muted">Not on file</span>
                                </div>
                                <div class="customer-contact-line">
                                    <i class="bi bi-envelope-fill"></i>
                                    <b>Email:</b>
                                    <span *ngIf="customerModel.email">{{ customerModel.email }}</span>
                                    <span *ngIf="!customerModel.email" class="text-muted">Not on file</span>
                                </div>
                                <button type="button" *ngIf="customerModel.customerId" class="btn btn-link p-0 mt-2" (click)="openCustomerPortal()">
                                    <i class="bi bi-box-arrow-up-right"></i> Open Customer Portal
                                </button>
                            </div>

                            <div class="customer-tax-assignment mt-2">
                                <b>Tax assignment:</b>
                                {{ customerModel.taxExempt ? 'Tax Exempt' : 'Taxable' }}
                            </div>

                            <div *ngIf="showPriceLevel" class="customer-tax-assignment">
                                <b class="me-1">Price level:</b>
                                <span *ngIf="priceLevelName">{{ priceLevelName }}</span>
                                <span *ngIf="!priceLevelName" class="text-muted">None</span>
                            </div>
                        </div>

                        <button type="button" class="btn btn-link ms-3 mt-1 p-0" (click)="editCustomer()">
                            <i class="bi bi-pencil-square"></i>
                        </button>
                    </div>
                </div>

                <div class="customer-summary-cards">
                    <div class="customer-summary-card">
                        <div class="summary-title">Total Balance</div>
                        <div class="summary-value" [ngClass]="amountSizeClass(totalOutstandingBalance)">
                            {{ totalOutstandingBalance | currency }}
                        </div>
                    </div>

                    <div class="customer-summary-card">
                        <div class="summary-title">Past Due</div>
                        <div class="summary-value"
                             [ngClass]="amountSizeClass(pastDueBalance)"
                             [class.text-danger]="pastDueBalance > 0">
                            {{ pastDueBalance | currency }}
                        </div>
                    </div>

                    <div class="customer-summary-card">
                        <div class="summary-title">Open Invoices</div>
                        <div class="summary-value">
                            {{ openInvoiceCount }}
                        </div>
                    </div>

                    <div class="customer-summary-card">
                        <div class="summary-title">Open Jobs</div>
                        <div class="summary-value">{{ openJobs.length }}</div>
                    </div>

                    <div class="customer-summary-card">
                        <div class="summary-title">Last Service</div>
                        <div class="summary-value summary-value-date">
                            <span *ngIf="lastServiceDate">{{ lastServiceDate | date:'MMM d, y' }}</span>
                            <span *ngIf="!lastServiceDate" class="text-muted">None</span>
                        </div>
                    </div>
                </div>

                <div class="customer-integration-cards">
                    <button type="button"
                            *ngIf="isQuickbooksEnabled"
                            class="integration-card integration-card-quickbooks"
                            title="Edit this customer's QuickBooks settings"
                            (click)="editCustomer()">
                        <div class="integration-card-title">
                            <img src="content/images/qb-logo.png" class="integration-logo" alt="" />
                            <span class="integration-wordmark">
                                <small>intuit</small>
                                quickbooks
                            </span>
                        </div>

                        <div *ngIf="quickbooksSyncState === 'synced'" class="integration-status text-success">
                            <i class="bi bi-check-circle-fill"></i> Connected
                        </div>
                        <div *ngIf="quickbooksSyncState === 'syncing'" class="integration-status text-warning">
                            <i class="bi bi-arrow-repeat"></i> Syncing
                        </div>
                        <div *ngIf="quickbooksSyncState === 'off'" class="integration-status text-muted">
                            <i class="bi bi-dash-circle"></i> Not linked
                        </div>

                        <div class="integration-card-sub" *ngIf="quickbooksLastSyncDate">
                            Last Sync: {{ quickbooksLastSyncDate | date:'shortDate' }}
                        </div>
                    </button>

                    <button type="button"
                            *ngIf="isBusinessCentralEnabled"
                            class="integration-card integration-card-business-central"
                            title="Edit this customer's Business Central settings"
                            (click)="editCustomer()">
                        <div class="integration-card-title">
                            <!-- Dynamics-style tile; there's no larger Business Central mark in the repo than the 28px sync icon -->
                            <svg class="integration-logo" viewBox="0 0 32 32" aria-hidden="true">
                                <defs>
                                    <linearGradient id="bcTile" x1="0" y1="0" x2="1" y2="1">
                                        <stop offset="0" stop-color="#0f6cbd" />
                                        <stop offset="1" stop-color="#00b7c3" />
                                    </linearGradient>
                                </defs>
                                <rect width="32" height="32" rx="7" fill="url(#bcTile)" />
                                <rect x="7" y="16" width="5" height="9" rx="1" fill="#fff" />
                                <rect x="13.5" y="10" width="5" height="15" rx="1" fill="#fff" />
                                <rect x="20" y="6" width="5" height="19" rx="1" fill="#fff" />
                            </svg>
                            <span class="integration-wordmark">
                                <small>Dynamics 365</small>
                                Business Central
                            </span>
                        </div>

                        <div *ngIf="businessCentralSyncState === 'synced'" class="integration-status text-success">
                            <i class="bi bi-check-circle-fill"></i> Connected
                        </div>
                        <div *ngIf="businessCentralSyncState === 'syncing'" class="integration-status text-warning">
                            <i class="bi bi-arrow-repeat"></i> Syncing
                        </div>
                        <div *ngIf="businessCentralSyncState === 'off'" class="integration-status text-muted">
                            <i class="bi bi-dash-circle"></i> Not linked
                        </div>

                        <div class="integration-card-sub" *ngIf="businessCentralLastSyncDate">
                            Last Sync: {{ businessCentralLastSyncDate | date:'shortDate' }}
                        </div>
                    </button>

                    <button type="button"
                            *ngIf="usingCreditCards"
                            class="integration-card integration-card-credit-card"
                            title="Manage this customer's cards on file"
                            (click)="openPaymentInfo()">
                        <i class="bi bi-pencil-square integration-card-edit"></i>

                        <div class="integration-card-title">
                            <!-- Same brand glyphs the Payment Info form uses, in the brand's colour -->
                            <i class="integration-logo card-brand" [ngClass]="creditCardBrandClass"></i>
                            <span *ngIf="defaultCreditCard" class="integration-wordmark">
                                &bull;&bull;&bull;&bull; {{ defaultCreditCard.accountNumberLastFour }}
                                <span *ngIf="defaultCreditCard.isDefault" class="integration-badge">Default</span>
                                <small class="integration-exp">Exp. {{ defaultCreditCard.expDate }}</small>
                            </span>
                            <span *ngIf="!defaultCreditCard" class="integration-wordmark">
                                Card on file
                                <small class="text-muted"><i class="bi bi-plus-circle"></i> Add a card</small>
                            </span>
                        </div>
                    </button>
                </div>
            </div>

            <div class="customer-dashboard-tabs">

                <button type="button"
                        class="dashboard-tab"
                        [class.active]="dashboardTabKey === 'Overview'"
                        [class.text-primary]="dashboardTabKey === 'Overview'"
                        (click)="setDashboardTab('Overview')">
                    Overview
                </button>

                <button type="button"
                        class="dashboard-tab"
                        [class.active]="dashboardTabKey === 'Accounting'"
                        [class.text-primary]="dashboardTabKey === 'Accounting'"
                        (click)="setDashboardTab('Accounting')">
                    Accounting
                </button>

                <button type="button"
                        class="dashboard-tab"
                        [class.active]="dashboardTabKey === 'Jobs'"
                        [class.text-primary]="dashboardTabKey === 'Jobs'"
                        (click)="setDashboardTab('Jobs')">
                    Jobs
                </button>

                <button type="button"
                        class="dashboard-tab"
                        [class.active]="dashboardTabKey === 'Communication'"
                        [class.text-primary]="dashboardTabKey === 'Communication'"
                        (click)="setDashboardTab('Communication')">
                    Communication
                </button>

                <button type="button"
                        class="dashboard-tab"
                        [class.active]="dashboardTabKey === 'Assets'"
                        [class.text-primary]="dashboardTabKey === 'Assets'"
                        (click)="setDashboardTab('Assets')">
                    Assets
                </button>
                <button type="button"
                        class="dashboard-tab"
                        [class.active]="dashboardTabKey === 'Photos & Attachments'"
                        [class.text-primary]="dashboardTabKey === 'Photos & Attachments'"
                        (click)="setDashboardTab('Photos & Attachments')">
                    Photos &amp; Attachments
                </button>

            </div>

            <div *ngIf="dashboardTabKey === 'Overview'" class="customer-overview-grid">
                <div class="dashboard-card">
                    <div class="dashboard-card-header">
                        <b>Open Jobs ({{ openJobs.length }})</b>
                        <a role="button" class="text-primary"
                           (click)="setDashboardTab('Jobs')">
                            View All Jobs →
                        </a>
                    </div>
                    <div class="mt-3">
                        <div *ngIf="openJobs.length === 0" class="text-muted mt-3">
                            No open jobs found.
                        </div>

                        <table *ngIf="openJobs.length > 0" class="dashboard-card-table">
                            <thead>
                                <tr>
                                    <th>Job #</th>
                                    <th>Description</th>
                                    <th>Scheduled</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let job of openJobs | slice:0:5" class="dashboard-card-row" (click)="openJob(job.jobId)">
                                    <td><b>{{ job.jobNumber }}</b></td>
                                    <td>{{ job.description }}</td>
                                    <td>
                                        <span *ngIf="job.scheduledDateTime">{{ job.scheduledDateTime | date:'MMM d, y' }}</span>
                                        <span *ngIf="!job.scheduledDateTime" class="text-muted">Unscheduled</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <a *ngIf="openJobs.length > 5" role="button" class="text-primary" (click)="setDashboardTab('Jobs')">
                            +{{ openJobs.length - 5 }} more
                        </a>
                    </div>
                </div>

                <div class="dashboard-card">
                    <div class="dashboard-card-header">
                        <b>Outstanding Invoices ({{ openInvoiceCount }})</b>
                        <a role="button" class="text-primary"
                           (click)="showCustomerInvoices()">
                            View All Invoices →
                        </a>
                    </div>

                    <div class="mt-3">

                        <div *ngIf="outstandingInvoices.length === 0"
                             class="text-muted mt-3">
                            No outstanding invoices.
                        </div>

                        <table *ngIf="outstandingInvoices.length > 0" class="dashboard-card-table">
                            <thead>
                                <tr>
                                    <th>Invoice #</th>
                                    <th>Due Date</th>
                                    <th class="text-end">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let invoice of outstandingInvoices" class="dashboard-card-row" (click)="openInvoice(invoice.invoiceId)">
                                    <td><b>{{ invoice.invoiceNumber }}</b></td>
                                    <td>{{ invoice.invoiceDueDate | date:'shortDate' }}</td>
                                    <td class="text-end"
                                        [class.text-danger]="isPastDue(invoice)">
                                        <b>{{ invoice.outstandingBalance | currency }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="dashboard-card">
                    <div class="dashboard-card-header">
                        <b>Recent Activity</b>

                        <!-- Recent Activity is the system log; the full log lives in the header dialog -->
                        <a role="button" class="text-primary"
                           (click)="openSystemLogs()">
                            View All Activity →
                        </a>
                    </div>

                    <div class="mt-3">
                        <system-logs [referenceId]="customerModel.customerId"
                                     [noteType]="0"
                                     [compact]="true"
                                     [limit]="4">
                        </system-logs>
                    </div>
                </div>

                <div class="dashboard-card">
                    <div class="dashboard-card-header">
                        <b>Assets</b>

                        <a role="button" class="text-primary"
                           (click)="setDashboardTab('Assets')">
                            View All Assets →
                        </a>
                    </div>

                    <div class="mt-3">
                        <div *ngIf="siteAssets.length === 0"
                             class="text-muted">
                            No site assets found.
                        </div>

                        <div *ngFor="let asset of siteAssets | slice:0:4"
                             class="mb-3">

                            <div class="fw-bold">
                                {{ getStructureTypeName(asset.structureTypeId) }}
                            </div>

                            <div *ngIf="asset.description"
                                 class="text-muted">
                                {{ asset.description }}
                            </div>

                            <div *ngIf="asset.volume"
                                 class="text-muted">
                                {{ asset.volume | number }} gallons
                            </div>
                        </div>

                        <a *ngIf="siteAssets.length > 4" class="text-primary"
                           role="button"
                           (click)="setDashboardTab('Assets')">
                            +{{ siteAssets.length - 4 }} more
                        </a>
                    </div>
                </div>
            </div>

            <!-- The customer's open sales-pipeline ticket(s), shown as a project timeline. Renders
                 nothing when there is no open project. -->
            <customer-project-progress *ngIf="dashboardTabKey === 'Overview'"
                                       #projectProgressRef
                                       [customer]="customerModel"
                                       (createJob)="createJob($event)"
                                       (createQuote)="createQuote($event)"
                                       (createInvoice)="createInvoice($event)"
                                       (createPayment)="createPayment()"
                                       (openJob)="openJob($event)"
                                       (openQuote)="openEstimate($event)"
                                       (openInvoice)="openInvoice($event)"
                                       (openLathamOrder)="openLathamOrder($event)">
            </customer-project-progress>

            <div *ngIf="dashboardTabKey === 'Accounting'" class="customer-accounting">

                <div class="customer-accounting-summary">
                    <button type="button"
                            class="accounting-summary-card"
                            [class.active]="accountingTabKey === 'Estimates'" [class.text-primary]="accountingTabKey === 'Estimates'"
                            (click)="setAccountingTab('Estimates')">

                        <div class="accounting-card-title">Estimates</div>

                        <div class="accounting-card-description">
                            View estimates and convert to jobs or invoices
                        </div>
                    </button>

                    <button type="button"
                            class="accounting-summary-card" [class.active]="accountingTabKey === 'Invoices'" [class.text-primary]="accountingTabKey === 'Invoices'" (click)="setAccountingTab('Invoices')">
                        <div class="accounting-card-title">Invoices</div>
                        <div class="accounting-card-description">
                            View, create, edit and send invoices
                        </div>
                    </button>

                    <button type="button"
                            class="accounting-summary-card" [class.active]="accountingTabKey === 'Payments'" [class.text-primary]="accountingTabKey === 'Payments'" (click)="setAccountingTab('Payments')">
                        <div class="accounting-card-title">Payments</div>
                        <div class="accounting-card-description">
                            Record payments and view payment history
                        </div>
                    </button>

                </div>

                <div *ngIf="accountingTabKey === 'Invoices'"
                     class="customer-accounting-grid">

                    <invoices-grid #invoicesGridRef
                                   [customerId]="customerModel.customerId"
                                   [autoSelectFirstRow]="false"
                                   [hideFilters]="true"
                                   [hideNewButton]="true"
                                   (onInvoiceSelected)="openInvoice($event)">
                    </invoices-grid>

                </div>

                <div *ngIf="accountingTabKey === 'Estimates'"
                     class="customer-accounting-grid">

                    <estimates-grid #estimatesGridRef
                                    [customerId]="customerModel.customerId"
                                    [autoSelectFirstRow]="false"
                                    [hideFilters]="true"
                                    [hideNewButton]="true"
                                    (onEstimateSelected)="openEstimate($event)">
                    </estimates-grid>

                </div>

                <div *ngIf="accountingTabKey === 'Payments'"
                     class="customer-accounting-grid">

                    <payments-grid #paymentsGridRef
                                   [customerId]="customerModel.customerId"
                                   [autoSelectFirstRow]="false"
                                   [hideFilters]="true"
                                   [hideNewButton]="true"
                                   (onPaymentSelected)="openPayment($event)">
                    </payments-grid>

                </div>

            </div>

            <!-- The appointment history cards the old customer page's "Appt. History" tab showed (AI
                 summary, search, one card per past appointment), with the job and its invoice opening
                 in the page's dialogs. Replaced the plain jobs grid here. -->
            <div *ngIf="dashboardTabKey === 'Jobs'">
                <job-history #jobHistoryRef
                             [customerId]="customerModel.customerId"
                             (openJob)="openJob($event)"
                             (openInvoice)="openInvoice($event)">
                </job-history>
            </div>

            <div *ngIf="dashboardTabKey === 'Photos & Attachments'" class="customer-accounting">
                <div class="customer-accounting-summary">
                    <button type="button"
                            class="accounting-summary-card"
                            [class.active]="documentsTabKey === 'Photos'" [class.text-primary]="documentsTabKey === 'Photos'"
                            (click)="documentsTabKey = 'Photos'">
                        <div class="accounting-card-title">Photos</div>
                        <div class="accounting-card-description">
                            Photos from this customer, their jobs, equipment and invoices
                        </div>
                    </button>

                    <button type="button"
                            class="accounting-summary-card"
                            [class.active]="documentsTabKey === 'Attachments'" [class.text-primary]="documentsTabKey === 'Attachments'"
                            (click)="documentsTabKey = 'Attachments'">
                        <div class="accounting-card-title">Attachments &amp; Documents</div>
                        <div class="accounting-card-description">
                            Attachments from this customer, their jobs, equipment and invoices
                        </div>
                    </button>
                </div>

                <!-- getUrl pulls every file attached to this customer anywhere in the system, not
                     just the ones uploaded onto the customer record itself. Uploads still land on
                     the customer's own folder. -->
                <div *ngIf="documentsTabKey === 'Photos'" class="customer-accounting-grid">
                    <documents-edit [documentKey]="customerModel.documentKey"
                                    documentType="Customers"
                                    folderType="photos"
                                    fileFilter="photos"
                                    getUrl="/documents/getAllFilesForCustomer"
                                    [canDelete]="customersAuthService.canEdit()"
                                    [allowTitleEditing]="customersAuthService.canEdit()"
                                    [hideFileDrop]="!customersAuthService.canEdit()"></documents-edit>
                </div>

                <div *ngIf="documentsTabKey === 'Attachments'" class="customer-accounting-grid">
                    <documents-edit [documentKey]="customerModel.documentKey"
                                    documentType="Customers"
                                    folderType="documents"
                                    fileFilter="documents"
                                    getUrl="/documents/getAllFilesForCustomer"
                                    [canDelete]="customersAuthService.canEdit()"
                                    [allowTitleEditing]="customersAuthService.canEdit()"
                                    [hideFileDrop]="!customersAuthService.canEdit()"></documents-edit>
                </div>
            </div>

            <div *ngIf="dashboardTabKey === 'Communication'"
                 class="customer-accounting">

                <div class="customer-accounting-summary">

                    <button type="button"
                            class="accounting-summary-card"
                            [class.active]="communicationTabKey === 'Customer Text'" [class.text-primary]="communicationTabKey === 'Customer Text'"
                            (click)="setCommunicationTab('Customer Text')">

                        <div class="accounting-card-title">Customer Text</div>
                        <div class="accounting-card-description">
                            View and send customer text messages
                        </div>
                    </button>

                    <button type="button"
                            class="accounting-summary-card"
                            [class.active]="communicationTabKey === 'Emails'" [class.text-primary]="communicationTabKey === 'Emails'"
                            (click)="setCommunicationTab('Emails')">

                        <div class="accounting-card-title">Emails</div>
                        <div class="accounting-card-description">
                            View customer email history
                        </div>
                    </button>

                    <button type="button"
                            class="accounting-summary-card"
                            [class.active]="communicationTabKey === 'Activities'" [class.text-primary]="communicationTabKey === 'Activities'"
                            (click)="setCommunicationTab('Activities')">

                        <div class="accounting-card-title">CRM Activities</div>
                        <div class="accounting-card-description">
                            Log calls, emails, texts and meetings and set the next outreach
                        </div>
                    </button>

                </div>

                <div *ngIf="communicationTabKey === 'Customer Text'"
                     class="customer-accounting-grid">
                    <div class="d-flex">
                        <div class="d-flex border-end">
                            <text-chat-conversations [customerId]="customerModel.customerId"
                                                     [customerPhoneNumber]="customerModel.cellPhone">
                            </text-chat-conversations>
                        </div>

                        <div class="chat-messages p-2 flex-fill">
                            <text-chat-messages></text-chat-messages>
                        </div>
                    </div>
                </div>

                <div *ngIf="communicationTabKey === 'Emails'"
                     class="customer-accounting-grid">

                    <div *ngIf="loadingCustomerEmails"
                         class="text-muted p-3">
                        Loading emails...
                    </div>

                    <div *ngIf="!loadingCustomerEmails && customerEmails.length === 0"
                         class="text-muted p-3">
                        No emails found for this customer.
                    </div>

                    <div *ngIf="!loadingCustomerEmails && customerEmails.length > 0"
                         class="d-flex">

                        <div style="width: 35%; border-right: 1px solid #ddd;">
                            <div *ngFor="let email of customerEmails"
                                 class="p-3 border-bottom"
                                 style="cursor: pointer;"
                                 (click)="selectedCustomerEmail = email">

                                <div class="fw-bold">
                                    {{ email.subject }}
                                </div>

                                <div class="text-muted small">
                                    {{ email.sentDate | date:'M/d/yyyy h:mm a' }}
                                </div>

                                <div class="text-muted small">
                                    {{ email.sentTo }}
                                </div>
                            </div>
                        </div>

                        <div style="width: 65%; padding: 16px;"
                             *ngIf="selectedCustomerEmail">

                            <div class="fw-bold mb-2">
                                {{ selectedCustomerEmail.subject }}
                            </div>

                            <div class="small mb-1">
                                <strong>From:</strong>
                                {{ selectedCustomerEmail.sendFrom }}
                            </div>

                            <div class="small mb-1">
                                <strong>To:</strong>
                                {{ selectedCustomerEmail.sentTo }}
                            </div>

                            <div class="small mb-3">
                                <strong>Sent:</strong>
                                {{ selectedCustomerEmail.sentDate | date:'M/d/yyyy h:mm a' }}
                            </div>

                            <div [innerHTML]="selectedCustomerEmail.body"></div>
                        </div>
                    </div>
                </div>

                <!-- The CRM tab from the old customer page. It edits the outreach entries and the
                     next-outreach schedule on the customer model, which is what puts the customer on
                     the CRM list, and persists through the normal customer save. -->
                <div *ngIf="communicationTabKey === 'Activities'"
                     class="customer-accounting-grid">
                    <crm-edit [customerModel]="customerModel"></crm-edit>

                    <div *ngIf="customersAuthService.canEdit()" class="customer-activities-actions">
                        <button type="button"
                                class="btn btn-outline-success"
                                [slick-button-spinner]="activitiesSpinnerStatus"
                                (click)="saveActivities()">
                            <i class="bi bi-check-circle"></i> Save Activities
                        </button>
                        <button type="button"
                                class="btn btn-outline-danger ms-2"
                                (click)="discardActivities()">
                            <i class="bi bi-x-circle"></i> Discard
                        </button>
                    </div>
                    <permission-denied *ngIf="!customersAuthService.canEdit()"
                                       [message]="'*You do not have permission to edit Customers.'"></permission-denied>
                </div>

            </div>
<div *ngIf="dashboardTabKey === 'Assets'"
     class="customer-assets customer-accounting">

    <div class="customer-assets-summary">
        <button type="button"
                class="accounting-summary-card"
                [class.active]="assetsTabKey === 'Site Assets'"
                [class.text-primary]="assetsTabKey === 'Site Assets'"
                (click)="setAssetsTab('Site Assets')">
            <div class="accounting-card-title">Site Assets</div>
            <div class="accounting-card-description">
                Manage pools, spas and other site structures
            </div>
        </button>

        <button type="button"
                class="accounting-summary-card"
                [class.active]="assetsTabKey === 'Site Log'"
                [class.text-primary]="assetsTabKey === 'Site Log'"
                (click)="setAssetsTab('Site Log')">
            <div class="accounting-card-title">Site Log</div>
            <div class="accounting-card-description">
                Configure fleet assets and site log requirements
            </div>
        </button>
    </div>

    <div *ngIf="assetsTabKey === 'Site Assets'" class="customer-assets-content">
        <assets [customerId]="customerModel.customerId"
                [documentKey]="customerModel.documentKey">
        </assets>
    </div>

    <div *ngIf="assetsTabKey === 'Site Log'" class="customer-assets-content">
        <site-log-edit [customerModel]="customerModel"></site-log-edit>
    </div>
</div>
        </div>
        <div *ngIf="!skeditPay && isEditingCustomer" style="padding-left: 15px;">
            <customer-edit-layout #customerEditLayoutRef
                                  [(customerModel)]="customerModel"
                                  (existingCustomerSelected)="existingCustomerSelected($event)">
            </customer-edit-layout>
        </div>
    </div>

    <!--<div class="row mt-3 d-flex pt-2 border-top ms-3 me-3">
    <div class="me-3" *ngIf="flagNonSignedServiceAgreement && !customerModel.acceptedTerms">
        <button class="btn btn-outline-primary align-self-r" [disabled]="!customerModel.email" (click)="sendServiceAgreement(customerModel.customerId)" [slick-button-spinner]="agreementspinnerStatus"><i class="far fa-envelope"></i> Send Service Agreement</button>
    </div>
    </div>-->

    <layout-footer>
        <div *ngIf="!isDialog && (skeditPay || isEditingCustomer)">
            <div class="flex-fill ms-1" *ngIf="!customersAuthService.canEdit()">
                <permission-denied [message]="'*You do not have permission to edit Customers.'"></permission-denied>
            </div>
            <div class="mt-2 pt-2 mb-3 me-3" style="min-width: 100%;">
                <div class="ms-1" *ngIf="customersAuthService.canEdit()" style="display: flex; justify-content: left;">
                    <button class="save-button btn btn-outline-success me-3" style="width: 140px;" (click)="saveCustomer()" [slick-button-spinner]="spinnerStatus"><i class="bi bi-check-circle"></i> Save </button>
                    <button class="cancel-button btn btn-outline-danger" style="width: 140px;" (click)="cancelEditCustomer()"> <i class="bi bi-x-circle"></i> Cancel </button>
                    <div *ngIf="!skeditPay" style="margin-left: auto;">
                        <div class="d-flex">
                            <button *ngIf="customerModel.acceptedTerms === true" class="mt-2 me-2 btn btn-outline-danger" (click)="resetCustomerSignedStatus()"><i class="bi bi-reset"></i>&nbsp;<b>Reset Signed Status</b></button>
                            <div *ngIf="customerModel.acceptedTerms === true" class="pt-2 mt-2 "><i class="bi bi-check-circle-fill text-success"></i>&nbsp;<b>Service Agreement Signed</b></div>
                        </div>
                        <div class="d-flex gap-2">
                            <button type="button" *ngIf="customerModel.acceptedTerms === false" style="width: 280px;" class="btn btn-outline-primary" [slick-button-spinner]="agreementspinnerStatus" (click)="sendServiceAgreement()">
                                <i class="bi bi-envelope"></i> Send Service Agreement
                            </button>
                            <button type="button" *ngIf="customerModel.customerId && customerModel.email" style="width: 280px;" class="btn btn-outline-primary" [slick-button-spinner]="portalInviteSpinnerStatus" (click)="sendPortalInviteLink()">
                                <i class="bi bi-envelope"></i> Send Portal Invite
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout-footer>
</div>

<slick-confirm-dialog #resetCustomerSignedStatusRef>
    Are you sure you want to reset the service agreement signed status for this customers? This action cannot be undone.
</slick-confirm-dialog>
<address-validation-dialog #addressValidationDialogRef></address-validation-dialog>

<!-- Dialog content is projected, so it gets built whether or not the dialog is showing.
     The flags keep these from loading until they're actually opened. -->
<slick-dialog #systemLogsDialogRef header="System Logs" [width]="800" [maxHeight]="600" (onClose)="systemLogsDialogOpen = false">
    <div *ngIf="systemLogsDialogOpen && customerModel">
        <system-logs [referenceId]="customerModel.customerId" [noteType]="0"></system-logs>
    </div>
</slick-dialog>

<slick-dialog #paymentInfoDialogRef header="Payment Info" [width]="900" (onClose)="onPaymentInfoClosed()">
    <div *ngIf="paymentInfoDialogOpen && customerModel">
        <payment-info-edit [customerModel]="customerModel"></payment-info-edit>
    </div>
</slick-dialog>
